import { createStore, applyMiddleware, combineReducers } from "redux";
import {composeWithDevTools} from 'redux-devtools-extension'
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// import logger from "redux-logger";
import thunk from "redux-thunk";
import moment from "moment";

// import reducers
import userReducer from "./user/userReducer";
import blogReducer from "./blog/blogReducer";
import commonReducer from "./common/commonReducer";
import socketReducer from "./socket/socketReducer";
import cometChatReducer from "./cometChat/cometChatReducer";
import scamReducer from "./scam/scamReducer";

// Persist config
const persistConfig = {
  key: "root",
  storage,
  version: 0,
  migrate: (state) => {
    // Persist Migration logic here
    if (state?._persist.version !== persistConfig?.version) {
      //just refreshing the storage for
      localStorage.clear();
    }
    return Promise.resolve(state);
  },
};

const rootReducer = combineReducers({
  userState: userReducer,
  blogState: blogReducer,
  commonState: commonReducer,
  socketState: socketReducer,
  cometChatState: cometChatReducer,
  scamState:scamReducer,
});

// Persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create store with middleware
const store = createStore(persistedReducer,composeWithDevTools(applyMiddleware(thunk)));
// const store = createStore(persistedReducer, applyMiddleware(logger, thunk));

// Subscribe to changes in the store
const unsubscribe = store.subscribe(() => {
  // This function will be called whenever the state in the store changes
  const currentState = store.getState();
  const userState = currentState.userState

  if (userState.isLoggedIn === true && userState?.userData?.last_login) {
    const lastLoginDate = moment(currentState.userState.userData.last_login).format('YYYY-MM-DD');
    const fiveDaysPreviousDate = moment().subtract(5, 'days').format('YYYY-MM-DD'); //from today

    const differenceInDays = moment(fiveDaysPreviousDate).diff(lastLoginDate, 'days');

    if (differenceInDays > 5) {
      localStorage.clear()
    }
  }

  //perform migration logic here:
  if (currentState?._persist?.version !== persistConfig.version) {
    localStorage.clear();
  }
});

// Unsubscribe when you no longer need to listen to store changes
// unsubscribe();

export default store;
